import {
    FETCH_TRANSACTIONS_BEGIN,
    FETCH_TRANSACTIONS_SUCCESS,
    FETCH_TRANSACTIONS_FAILURE,
    CREATE_ORG_TRANSACTION_BEGIN,
    CREATE_ORG_TRANSACTION_SUCCESS,
    CREATE_ORG_TRANSACTION_FAILURE,
    GET_ORG_TRANSACTION_BY_ID_BEGIN,
    GET_ORG_TRANSACTION_BY_ID_SUCCESS,
    GET_ORG_TRANSACTION_BY_ID_FAILURE,
    UPDATE_ORG_TRANSACTION_SUCCESS,
    UPDATE_ORG_TRANSACTION_FAILURE,
    DELETE_ORG_TRANSACTION_SUCCESS,
    DELETE_ORG_TRANSACTION_FAILURE,
    CLEAR_TRANSACTIONS,
    UPDATE_TRANSACTIONS_BEGIN,
    CLEAR_TRANSACTIONS_NOTIFICATION
} from 'actions/admin/walletActions';


const initialState = {
    transactions: [],
    loading: false,
    error: null,
    notification: null,
    dummyData: [...Array(10)],
    pagination: {},
    transactionDetail: {},
    balance: 0,
    formSuccess: false,
    searchResult: []
}

export default function walletReducer(state = initialState, action) {
    switch(action.type) {
        case FETCH_TRANSACTIONS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                transactions: action.data.organisation_wallet_transaction,
                pagination: action.data.pagination,
                balance: action.data.balance,
                organisation: action.data.organisation
            };
        case FETCH_TRANSACTIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                transactions: []
            };

        case CREATE_ORG_TRANSACTION_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CREATE_ORG_TRANSACTION_SUCCESS:
            return {
                ...state,
                loading: false,
                formSuccess: true
            };
        case CREATE_ORG_TRANSACTION_FAILURE:
            return {
                ...state,
                loading: false,
                formSuccess: false,
                error: action.payload.error,
            };
        case GET_ORG_TRANSACTION_BY_ID_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ORG_TRANSACTION_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                transactionDetail: action.data
            };

        case GET_ORG_TRANSACTION_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        case UPDATE_TRANSACTIONS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_ORG_TRANSACTION_SUCCESS:

            return {
                ...state,
                loading: false,
                formSuccess: true,
                transactionDetail: action.data
            }
        case UPDATE_ORG_TRANSACTION_FAILURE:
            return {
                ...state,
                loading: false,
                formSuccess: false,
                error: action.payload.error,
            };
        case DELETE_ORG_TRANSACTION_SUCCESS:
            return {
                ...state,
                formSuccess: true,
                loading: false,
                notification: action.msg
            };
        case DELETE_ORG_TRANSACTION_FAILURE:
            return {
                ...state,
                loading: false,
                formSuccess: false,
                error: action.payload.error,
            };
        case CLEAR_TRANSACTIONS:
            return {
                ...state,
                transactions: [],
                loading: false,
                error: null,
                transactionDetail: {},
                formSuccess: false
            }
        case CLEAR_TRANSACTIONS_NOTIFICATION:
            return {
                ...state,
                error:null,
                notification:null
            }
        default:
            return state
    }
}
